import { unifiedFlowPaths } from 'app/navigation/paths'
import { useFlags } from 'launchdarkly-react-client-sdk'

import Button from 'common/components/button'
import useApproveElementMutation from 'features/unifiedFlow/api/mutations/useApproveElementMutation'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

type Props = {
  variants: { _id: string }[]
  selectedCount: number
  isApproveButtonDisabled: boolean
}

const ApprovalsTableActionButtons = ({
  variants,
  selectedCount,
  isApproveButtonDisabled,
}: Props) => {
  const { content } = useContent()
  const { campaignThoughtspotSnowflake: isCampaignThoughtspotSnowflakeOn } =
    useFlags()
  const approveElementMutation = useApproveElementMutation({
    redirectTo: isCampaignThoughtspotSnowflakeOn
      ? unifiedFlowPaths.manage
      : unifiedFlowPaths.results,
  })
  const { data: selectedElement } = useSelectedElement()

  const handleApprove = () => {
    if (selectedElement && content) {
      approveElementMutation.mutate({
        accountId: content.account_id,
        element_id: selectedElement.element_id,
        content_id: content?._id,
        variant_ids: variants.map(({ _id }) => _id),
      })
    }
  }

  return (
    <Button
      disabled={approveElementMutation.isLoading || isApproveButtonDisabled}
      loading={approveElementMutation.isLoading}
      className="ml-4"
      variant="primary"
      onClick={handleApprove}
    >
      Approve{selectedCount > 0 && ` (${selectedCount})`}
    </Button>
  )
}

export default ApprovalsTableActionButtons
